import React from 'react';
import UploadComponent, { ErrorMessage } from '@cp/src/components/UploadComponent/UploadComponent';
import styles from '../Enach.module.scss';
import UploadErrorComponent from '@cp/src/components/UploadComponent/UploadErrorComponent';
import UploadLoadingComponent from '@cp/src/components/UploadComponent/UploadLoadingComponent';
import UploadSuccessComponent from '@cp/src/components/UploadComponent/UploadSuccessComponent';
import { CustomFileUploadComponent } from './CustomFileUploadComponent';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { ENACH_TRIGGER_TYPE } from '../Constants/types';
import { ENACH_CLICKSTREAM } from '@cp/src/service/clickStream.constant';

interface FileUploadStateComponentProps {
  error: ErrorMessage;
  file: File | null;
  setFile: (file: File | null) => void;
  setError: (errorMessage: ErrorMessage) => void;
  enachTriggerType: ENACH_TRIGGER_TYPE | null;
  showLoadingComponent: boolean;
}

const FileUploadStateComponent: React.FC<FileUploadStateComponentProps> = ({
  error,
  file,
  setFile,
  setError,
  enachTriggerType,
  showLoadingComponent
}) => {
  const hasErrorState = error?.message;
  const hasLoadingState = !hasErrorState && file && showLoadingComponent;
  const hasSuccessState = !hasErrorState && file && !showLoadingComponent;

  if (hasErrorState) {
    return (
      <div className={styles.errorContainer}>
        <UploadErrorComponent
          containerClassName={styles.uploadErrorContainer}
          message={error?.message}
          fileName={error?.fileName || ''}
          showRetryIcon={false}
          showValidationText={false}
          onCancel={() => {
            setError({ message: '', fileName: '' });
            setFile(null);
          }}
        />
      </div>
    );
  }
  if (hasLoadingState) {
    return (
      <UploadLoadingComponent
        containerClassName={styles.uploadLoadingContainer}
        name={file?.name || ''}
        isInProgress={true}
        onCancel={() => {
          setFile(null);
        }}
      />
    );
  }
  if (hasSuccessState) {
    return (
      <UploadSuccessComponent
        containerClassName={styles.uploadSuccessContainer}
        name={file?.name}
        isInProgress={false}
        onCancel={() => {
          setFile(null);
        }}
      />
    );
  }
  return (
    <UploadComponent
      setFile={setFile}
      disabled={!enachTriggerType}
      uploadedFileType={enachTriggerType as string}
      clickstreamEvent={ENACH_CLICKSTREAM.LH_ENACH_TRIGGER_FILE_UPLOAD_ATTEMPT}
      file={file}
      uploadContentContainer={CustomFileUploadComponent}
      containerClassName={styles.uploadContainer}
      supportedFile=".csv"
      setHasError={setError}
      MAX_FILE_SIZE_IN_MB={5}
      onErrorCallbackFunction={() => {
        toast.error('Please select a file size less than 5mb');
      }}
    />
  );
};

export default FileUploadStateComponent;
